import { UNSAVED_CHANGES_MESSAGE } from "@components/misc/UnsavedChangesPrompt";
import { useNavigate } from "react-router-dom";

const useHandleCancel = (hasUnsavedChanges: boolean) => {
    const navigate = useNavigate();

    return () => {
        if (hasUnsavedChanges) {
            const confirmLeave = window.confirm(UNSAVED_CHANGES_MESSAGE);
            if (confirmLeave) {
                navigate(-1); // Go back to the previous page
            }
        } else {
            navigate(-1); // No unsaved changes, so just navigate back
        }
    };
};

export default useHandleCancel;
